import { defineMessages } from 'react-intl';

export const teamTrialUpgradeRequestButtonMessages = defineMessages({
  requestToUpgrade: {
    id: 'Trh9ADe8Jq',
    defaultMessage: 'Request to upgrade',
    description:
      'Primary label on the non-admin team trial upgrade request control before the user sends a request; {planName} is Practice or Clinician',
  },
  requestSentToAdmin: {
    id: '5ctstYdAAw',
    defaultMessage: 'Request sent to your admin',
    description:
      'Label on the team trial upgrade request button after the user sends a request (disabled state)',
  },
});
